module.exports = __webpack_public_path__ + "media/img/home/clients-map/b4c-8cd81e7b374c6c4c71031d80e806132d.svg";